// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"SummaryCard_tableContainer__cxI56","table":"SummaryCard_table__1xOBs"};